module.exports = __webpack_public_path__ + "static/media/prev-page.db361ecb.svg";